import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  CART_ITEM_PATH,
  CART_PATH,
  MENU_ITEM_DETAIL_PATH,
  MENU_ITEM_UPSELL_DETAIL_PATH,
  ORDER_FULFILLMENT_SETTINGS_PATH
} from 'catering/constants/paths';
import {
  UPSELL,
  STANDARD
} from 'bento-ordering/cart/constants/conversionMethods';
import {
  CartContainer,
  CartItemContainer,
  MenuItemDetailsContainer,
  OrderFulfillmentSettingsContainer
} from 'catering/containers';

function MenuNestedRoutes(props) {
  return (
    <Switch>
      <Route exact path={CART_PATH}>
        <CartContainer />
      </Route>
      <Route exact path={CART_ITEM_PATH}>
        <CartItemContainer {...props} />
      </Route>
      <Route path={ORDER_FULFILLMENT_SETTINGS_PATH}>
        <OrderFulfillmentSettingsContainer />
      </Route>
      <Route exact path={MENU_ITEM_UPSELL_DETAIL_PATH}>
        <MenuItemDetailsContainer {...props} conversionMethod={UPSELL} />
      </Route>
      <Route path={MENU_ITEM_DETAIL_PATH}>
        <MenuItemDetailsContainer {...props} conversionMethod={STANDARD} />
      </Route>
    </Switch>
  );
}

export default MenuNestedRoutes;
